import { render, staticRenderFns } from "./qualityBoard.vue?vue&type=template&id=6188b670&scoped=true"
import script from "./qualityBoard.vue?vue&type=script&lang=js"
export * from "./qualityBoard.vue?vue&type=script&lang=js"
import style0 from "./qualityBoard.vue?vue&type=style&index=0&id=6188b670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188b670",
  null
  
)

export default component.exports